module.exports = __webpack_public_path__ + "static/media/Corphish_gaussian2.8e40d8b3.png";